import { PanelCreationError } from './errors/panelCreationError';
function setPanelPetriGlobalConfig(controllerConfig) {
    const isPanelExperimentsGlobalConfigEnabled = controllerConfig.essentials.experiments.enabled('specs.blocks-preview-client.panelExperimentsGlobalConfig');
    if (!isPanelExperimentsGlobalConfigEnabled) {
        return;
    }
    const { location } = controllerConfig.wixCodeApi;
    const { siteOwnerId, userId } = location.query;
    if (!siteOwnerId || !userId) {
        return;
    }
    self.__WIXEXP_CONDUCTION_METHOD_ = 'owner-account';
    self.__WIXEXP_LOGGED_IN_USER_ID_ = userId;
    self.__WIXEXP_OWNER_ACCOUNT_ID_ = siteOwnerId;
}
export async function createPanelController(controllerConfig, createPanelFn) {
    try {
        const panelController = await createPanelFn(controllerConfig);
        setPanelPetriGlobalConfig(controllerConfig);
        /* istanbul ignore next */
        return {
            pageReady: (scoped$w) => {
                if (panelController?.pageReady) {
                    return panelController.pageReady(scoped$w);
                }
            },
            exports: () => ({}),
        };
    }
    catch (e) {
        throw new PanelCreationError(e);
    }
}
//# sourceMappingURL=createPanelController.js.map